import { useAuthenticatedState } from "../api-authorization/useAuthenticatedState";

/**
 * Hook to get the current user id.
 */
export function useCurrentUserId(): string | undefined {
    const { user } = useAuthenticatedState({ includeUser: true });
    return user?.sub;
}
